function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 21,
  height: 19,
  rx: 3.5,
  fill: "#F8F9FB"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 21,
  height: 19,
  rx: 3.5,
  stroke: "#404040"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.48828 14V13.209L10.9492 10.6504C11.2096 10.377 11.4245 10.1361 11.5938 9.92773C11.7663 9.71615 11.8949 9.51595 11.9795 9.32715C12.0674 9.13835 12.1113 8.93815 12.1113 8.72656C12.1113 8.48242 12.0544 8.27246 11.9404 8.09668C11.8265 7.9209 11.6719 7.78581 11.4766 7.69141C11.2812 7.59701 11.0599 7.5498 10.8125 7.5498C10.5521 7.5498 10.3258 7.60352 10.1338 7.71094C9.94173 7.8151 9.79199 7.96484 9.68457 8.16016C9.5804 8.35221 9.52832 8.57845 9.52832 8.83887H8.4834C8.4834 8.39616 8.58431 8.00879 8.78613 7.67676C8.99121 7.34473 9.27116 7.08757 9.62598 6.90527C9.98405 6.71973 10.3877 6.62695 10.8369 6.62695C11.2959 6.62695 11.6995 6.7181 12.0479 6.90039C12.3962 7.08268 12.668 7.33008 12.8633 7.64258C13.0586 7.95182 13.1562 8.30176 13.1562 8.69238C13.1562 8.96257 13.1058 9.22624 13.0049 9.4834C12.9072 9.74056 12.7331 10.0286 12.4824 10.3477C12.235 10.6634 11.89 11.0443 11.4473 11.4902L10.002 13.0039V13.0625H13.2734V14H8.48828Z",
  fill: "#404040"
});

function SvgStep2Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2Icon);
export default __webpack_public_path__ + "static/media/step2Icon.8ead97fb.svg";
export { ForwardRef as ReactComponent };